// Content can come from an external source that uses single newlines as
// intended line breaks, which Markdown would otherwise collapse. Convert each
// single newline into a Markdown hard break (two trailing spaces) so the line
// break is preserved, while leaving blank-line paragraph separators untouched.
// This avoids injecting visible characters between blocks, which previously
// produced phantom empty lines in the rendered output.
export function prepareMarkdownContent(content?: string): string {
  if (!content) return ''

  return (
    content
      // Normalize Windows/old-Mac line endings so paragraph detection and hard
      // breaks behave the same regardless of where the content was authored.
      .replaceAll(/\r\n?/g, '\n')
      // Strip trailing whitespace per line so whitespace-only lines count as
      // blank paragraph separators; intended hard breaks are re-added below.
      .replaceAll(/[\t ]+$/gm, '')
      .split(/\n{2,}/)
      .map((block) => block.replaceAll('\n', '  \n'))
      .join('\n\n')
  )
}

export function removeMarkdown(markdown: string) {
  if (!markdown) return ''

  // Step 1: Remove markdown-specific syntax using regular expressions
  return (
    markdown
      // Remove headers (e.g., ## Header)
      .replaceAll(/^#{1,6}\s+/gm, '')
      // Remove emphasis (e.g., **bold**, *italic*, __bold__, _italic_)
      .replaceAll(/(\*\*|__)(.*?)\1/g, '$2')
      .replaceAll(/(\*|_)(.*?)\1/g, '$2')
      // Remove links (e.g., [text](url))
      .replaceAll(/\[(.*?)]\(.*?\)/g, '$1')
      // Remove images (e.g., ![alt text](url))
      .replaceAll(/!\[(.*?)]\(.*?\)/g, '$1')
      // Remove inline code (e.g., `code`)
      .replaceAll(/`(.*?)`/g, '$1')
      // Remove blockquotes (e.g., > quote)
      .replaceAll(/^\s*>\s+/gm, '')
      // Remove unordered lists (e.g., * item)
      .replaceAll(/^\s*[*+-]\s+/gm, '')
      // Remove ordered lists (e.g., 1. item)
      .replaceAll(/^\d+\.\s+/gm, '')
      // Remove horizontal rule (e.g., --- or ***)
      .replaceAll(/^-{3,}|_{3,}|\*{3,}/gm, '')
      // Remove tables, pipes, etc. (e.g., | col1 | col2 |)
      .replaceAll(/^\|.*?\|$/gm, '')
      // Remove extra spaces or newlines
      .replaceAll(/\s{2,}/g, ' ')
      .trim()
  )
}
